// extracted by mini-css-extract-plugin
export default {"checkedMark":"CheckedMark_checkedMark__MmHUH"};